var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{staticClass:"container-grid-convert-modal",attrs:{"visible":_vm.visible,"title":"画面选择","okButtonProps":{
    props: {
      disabled: !_vm.activeItem
    }
  }},on:{"cancel":_vm.close,"ok":_vm.handleOK}},_vm._l((_vm.containerGridIcons),function(item){return _c('button',{key:item.name,staticClass:"container-grid-convert-modal__item",class:{
      'container-grid-convert-modal__item--active': _vm.activeItem === item.name
    },attrs:{"type":"button"},on:{"click":function($event){return _vm.handleSelect(item)}}},[_c('shape-renderer',{staticClass:"shape-icon__shape",attrs:{"params":{
        shape: 'path',
        width: 60,
        height: 40,
        strokeWidth: 0,
        color: 'var(--color)',
        d: item.d,
        shapeX: 0,
        shapeY: 0,
        shapeScale: 1
      }}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }